export default "__VITE_ASSET__CDUAkb6f__"